import "./SendoutSessionListScreen.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import SendoutSessionListTableComponent from "../sendout-session-list-table/SendoutSessionListTableComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import {Download} from "@mui/icons-material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import SendoutsFilterComponent from "../sendouts-filter/SendoutsFilterComponent";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import commonService from "../../../shared/services/common.service";

interface SendoutSessionListScreenProps {

}

const FiltersInitialState: any = {
    search: '',
    createdByObjs: [],
    createdByIds: [],
    labIds: [],
    labObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['labObjs', 'createdByObjs'];

const SendoutSessionListScreen = (props: SendoutSessionListScreenProps) => {

    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {
        labListLite,
        userList
    } = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));


    useEffect(() => {
        dispatch(setCurrentNavParams("Sendout","Sendout"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._lab.downloadSendOutCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'sendOutSessionList', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };

            if (queryParamData?.labIds?.length) {
                data['labIds'] = queryParamData.labIds.split(',') || [];
            }
            data['labObjs'] = labListLite.filter((item: any) => data['labIds']?.includes(item?.id?.toString()));

            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, labListLite, userList]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    return (
        <div className="send-out-session-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Sendouts"}
                                id="search_input"
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="page-extra-options">
                            {
                                CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }

                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                commonService.checkAccess('SendOuts', "sendOutsCSV", currentUser?.userAccessModules) &&

                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={downloadCSV}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                    isLoading={isCSVDownloading}
                                >
                                    CSV
                                </ButtonComponent>
                            }

                        </div>
                    </div>
                    <>
                        <SendoutSessionListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>

            <DrawerComponent open={showFilterDrawer}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             className={"drawer-wrapper"}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <SendoutsFilterComponent
                    filtersData={filterData}
                    onFiltersApply={applyFilters}
                    clearAllFilters={clearAllFilters}
                />
            </DrawerComponent>
        </div>
    );

};

export default SendoutSessionListScreen;
